// @flow
import {
    GENDER_MEN_CODE,
    GENDER_WOMEN_CODE,
    GENDER_KIDS_CODE,
    GENDER_UNISEX_CODE,
} from 'constants/gender';
import {GENDER} from 'constants/actions';
import type {ActionType} from 'constants/flow/flowTypes';

import type {GenderType} from './genderType';

export const initialState = {
    genders: {
        men: GENDER_MEN_CODE,
        women: GENDER_WOMEN_CODE,
        kids: GENDER_KIDS_CODE,
        unisex: GENDER_UNISEX_CODE,
    },
    currentGender: GENDER_UNISEX_CODE,
};

/**
 * Gender reducer
 * @param {GenderType} state - State
 * @param {ActionType<number>} action - Action
 * @returns {GenderType} New state
 */
export default function gender(
    state: GenderType = initialState,
    action: ActionType<number>,
): GenderType {
    switch (action.type) {
        case GENDER.SET:
            return {
                ...state,
                currentGender: action.payload,
            };
        default:
            return state;
    }
}
